import angular from 'angular';
import numberSpinner from './numberSpinner';
import './style.scss';

export default angular
  .module('components.numberSpinner', [])
  .component('numberSpinner', numberSpinner).name;
